/* eslint-disable react/no-danger */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import './overviewComponent.scss';
import DOMPurify from 'dompurify';

function createMarkup(text) {
  return { __html: text };
}

function OverviewComponent({ titleText, content, item }) {
  const initialState = useSelector((state) => state.runSeqReducer);
  const [isCollapsed, onCollapse] = useState(item && item !== 1);
  const title = titleText || 'Overview';
  const sanitizedContent = DOMPurify.sanitize(content);
  return (
    <div className="row container_overview">
      <div className="col-lg-12">
        <CybsCard
          dataTest="overview-card"
          header={
            <CybsActionBar
              dataTest="payment-info-with-collapsible"
              i18n={{ title }}
              collapsible={{
                isOpen: !isCollapsed,
                onClick: () => {
                  onCollapse(!isCollapsed);
                }
              }}
            />
          }
          isCollapsed={isCollapsed}
          bodyMaxHeight={200}
        >
          {!content ? <p>{initialState.overview}</p> : ''}
          <div dangerouslySetInnerHTML={createMarkup(sanitizedContent)} />
        </CybsCard>
      </div>
    </div>
  );
}

export default OverviewComponent;
